import utils from "./utils";
import httpService from "./httpService";

export default {
  findAllForBanHanh(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("/bookDocView/findAllForBanHanh", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/bookDocView/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/bookDocViewService.js